import literata from "@fontsource-variable/literata/files/literata-latin-opsz-normal.woff2?url"
import instrumentSans from "@fontsource-variable/instrument-sans/files/instrument-sans-latin-wght-normal.woff2?url"

/**
 * The faces every page sets on first paint, fetched beside the stylesheet
 * rather than after it, so neither shows its fallback while loading. Latin
 * covers English and Spanish; the italic, the mono and the other scripts load
 * only when a page uses them.
 *
 * The URLs are the ones globals.css resolves to, so the browser reuses the
 * preloaded file. A font is always fetched in CORS mode, hence `crossOrigin`.
 */
export const fontPreloadLinks = [literata, instrumentSans].map((href) => ({
  rel: "preload",
  href,
  as: "font",
  type: "font/woff2",
  crossOrigin: "anonymous" as const,
}))
